// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BookingSessionResponse

export type BookingSessionApiResponse = {
	id: string;
	pax: number;
	sessionId: string;
	sessionInstanceId: string | null;
};

export type BookingSession = {
	id: string;
	pax: number;
	sessionId: string;
	sessionInstanceId: string | null;
};

export function hydrateBookingSession(data: BookingSessionApiResponse): BookingSession {
	return { ...data };
}